import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';


import { showLoading, hideLoading } from '../../../../store/app';
import { toastr } from '../../../../components/CustomToast';
import WebAPIClient, {
  errorResponseToastr,
} from '../../../../api/_energytracer';

export default function BenchmarkOrgs() {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const [orgId, setOrgId] = useState(null);

  const handleLoading = (loading) => {
    if (loading) {
      setIsLoading(true);
      dispatch(showLoading());
    } else {
      setIsLoading(false);
      dispatch(hideLoading());
    }
  };



  const handleCreateOrg = async () => {
    handleLoading(true);
    let url = 'veregy_benchmarking/create_resource';
    let payload = { 'resource_type': 'organization', 'resource_id': orgId }

    try {
      await new WebAPIClient().POST(url, payload);
      toastr.success({
        title: 'Organization Created',
      });
    } catch (err) {
      errorResponseToastr(err);
    } finally {
      handleLoading(false);
      dispatch(hideLoading());
    }
  };

  return <div>
    <h3>Create Verified Organization</h3>
    <form>
      <List disablePadding>
        <ListItem disableGutters>
          <TextField
            fullWidth
            variant='standard'
            id='value'
            label={`Organization ID`}
            value={orgId ? orgId : ''}
            onChange={(e) => setOrgId(e.target.value)}
          />
        </ListItem>


        <Button
          type='submit'
          onClick={handleCreateOrg}
          color='primary'
          variant='contained'
          disabled={
            !orgId ||
            isLoading
          }>
          Submit
        </Button>
      </List>
    </form>
  </div>
}